class MemoryPhotoUpload extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const input = this.querySelector('input[type="file"]');
    const form = input?.form;
    const error = this.querySelector('[data-photo-error]');
    const names = this.querySelector('[data-photo-names]');
    if (!input || !form) return;

    input.addEventListener('invalid', () => {
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }, { signal });

    input.addEventListener('change', () => {
      const files = Array.from(input.files);
      error.hidden = files.length > 0;
      input.setAttribute('aria-invalid', String(files.length === 0));
      names.replaceChildren(...files.map(file => {
        const item = document.createElement('li');
        item.textContent = file.name;
        return item;
      }));
    }, { signal });

    form.addEventListener('formdata', event => {
      event.formData.delete(input.name);
      Array.from(input.files).forEach((file, index) => {
        event.formData.set(`properties[Upload Your Photo ${index + 1}]`, file, file.name);
      });
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('memory-photo-upload')) {
  customElements.define('memory-photo-upload', MemoryPhotoUpload);
}
